export const config = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  },
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    region: import.meta.env.VITE_COGNITO_REGION || 'ap-southeast-1',
  },
  storage: {
    clientIdKey: 'esafx_client_id',
    languageKey: 'i18nextLng',
  },
} as const
